var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUseCasesSmall2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 156,
    height: 144,
    viewBox: "0 0 156 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 156,
    height: 144,
    rx: 20,
    fill: "#ECFFFA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.456 115.4H17.928V125H16.456V115.4ZM24.52 125H23.048V115.4H24.52V125ZM23.464 120.856H17.448V119.608H23.464V120.856ZM27.9048 115.4H33.9688V116.6H27.9048V115.4ZM27.8408 123.8H33.9368V125H27.8408V123.8ZM27.7928 120.712V119.512H33.4248V120.712H27.7928ZM28.7368 125H27.2648V115.4H28.7368V125ZM40.0065 116.696H38.7905L39.4785 115.784C39.3612 116.157 39.2225 116.584 39.0625 117.064C38.9132 117.544 38.7478 118.035 38.5665 118.536C38.3958 119.037 38.2252 119.528 38.0545 120.008L36.2305 125H34.7105L38.4225 115.4H40.3745L44.1025 125H42.5185L40.6945 120.008C40.5238 119.528 40.3478 119.032 40.1665 118.52C39.9958 118.008 39.8358 117.517 39.6865 117.048C39.5372 116.568 39.4145 116.147 39.3185 115.784L40.0065 116.696ZM41.9585 122.312H36.7745V121.192H41.9585V122.312ZM46.9089 125V123.752H51.7249V125H46.9089ZM47.2449 115.4V125H45.7729V115.4H47.2449ZM51.401 116.712V115.4H59.081V116.712H51.401ZM54.505 115.608H55.977V125H54.505V115.608ZM60.7966 115.4H62.2686V125H60.7966V115.4ZM68.8606 125H67.3886V115.4H68.8606V125ZM67.8046 120.856H61.7886V119.608H67.8046V120.856ZM75.3014 125.192C74.5654 125.192 73.9254 125.085 73.3814 124.872C72.8374 124.648 72.384 124.323 72.0214 123.896C71.6587 123.469 71.3867 122.947 71.2054 122.328C71.0347 121.709 70.9494 120.995 70.9494 120.184C70.9494 119.107 71.12 118.2 71.4614 117.464C71.8027 116.728 72.2987 116.168 72.9494 115.784C73.6107 115.4 74.416 115.208 75.3654 115.208C76.1547 115.208 76.8267 115.331 77.3814 115.576C77.9467 115.821 78.3947 116.184 78.7254 116.664C79.056 117.133 79.28 117.72 79.3974 118.424L78.0214 118.744C77.84 117.955 77.5414 117.379 77.1254 117.016C76.72 116.653 76.128 116.472 75.3494 116.472C74.624 116.472 74.048 116.621 73.6214 116.92C73.1947 117.219 72.8854 117.645 72.6934 118.2C72.5014 118.755 72.4054 119.416 72.4054 120.184C72.4054 120.995 72.5014 121.683 72.6934 122.248C72.8854 122.803 73.1947 123.229 73.6214 123.528C74.048 123.816 74.608 123.96 75.3014 123.96C75.8774 123.96 76.3467 123.88 76.7094 123.72C77.0827 123.549 77.376 123.293 77.5894 122.952C77.8134 122.611 77.9894 122.168 78.1174 121.624L79.4934 121.928C79.376 122.643 79.1467 123.245 78.8054 123.736C78.4747 124.216 78.016 124.579 77.4294 124.824C76.8534 125.069 76.144 125.192 75.3014 125.192ZM85.269 116.696H84.053L84.741 115.784C84.6237 116.157 84.485 116.584 84.325 117.064C84.1757 117.544 84.0103 118.035 83.829 118.536C83.6583 119.037 83.4877 119.528 83.317 120.008L81.493 125H79.973L83.685 115.4H85.637L89.365 125H87.781L85.957 120.008C85.7863 119.528 85.6103 119.032 85.429 118.52C85.2583 118.008 85.0983 117.517 84.949 117.048C84.7997 116.568 84.677 116.147 84.581 115.784L85.269 116.696ZM87.221 122.312H82.037V121.192H87.221V122.312ZM95.7554 120.712L98.8594 124.68V125H97.2434L94.2994 120.76L95.7554 120.712ZM91.8514 116.6L92.5074 115.832V125H91.0354V115.4H94.7474C95.59 115.4 96.278 115.507 96.8114 115.72C97.3447 115.933 97.7394 116.259 97.9954 116.696C98.2514 117.123 98.3794 117.661 98.3794 118.312C98.3794 118.952 98.2354 119.501 97.9474 119.96C97.67 120.419 97.2594 120.771 96.7154 121.016C96.1714 121.261 95.51 121.384 94.7314 121.384H91.8674V120.184H94.6194C95.366 120.184 95.9367 120.04 96.3314 119.752C96.726 119.453 96.9234 118.984 96.9234 118.344C96.9234 117.917 96.8487 117.581 96.6994 117.336C96.5607 117.08 96.3207 116.893 95.9794 116.776C95.638 116.659 95.174 116.6 94.5874 116.6H91.8514ZM101.328 115.4H107.392V116.6H101.328V115.4ZM101.264 123.8H107.36V125H101.264V123.8ZM101.216 120.712V119.512H106.848V120.712H101.216ZM102.16 125H100.688V115.4H102.16V125Z",
    fill: "#0F1936"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M101.151 58.5554V40.4998L85.5197 31.472L69.8889 40.4998V58.5554L85.5197 67.5832L101.151 58.5554Z",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M101.151 58.5551L85.5199 67.5828V49.5273L101.151 40.4995V58.5551Z",
    fill: "#0F1936",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M85.5197 49.5276L69.8889 58.5554V40.4998L85.5197 31.472V49.5276Z",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M85.5197 67.5828L69.8889 58.5551V40.4995L85.5197 49.5273V67.5828Z",
    fill: "#ECFFFA",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M101.151 40.4998L85.5197 49.5276L69.8889 40.4998L85.5197 31.472L101.151 40.4998Z",
    fill: "#ECFFFA",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M116.782 85.6388V67.5832L101.151 58.5554L85.5199 67.5832V85.6388L101.151 94.6665L116.782 85.6388Z",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M116.782 85.6384L101.151 94.6662V76.6107L116.782 67.5829V85.6384Z",
    fill: "#0F1936",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M101.151 76.611L85.5199 85.6387V67.5832L101.151 58.5554V76.611Z",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M101.151 94.6662L85.5199 85.6384V67.5829L101.151 76.6107V94.6662Z",
    fill: "#ECFFFA",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M116.782 67.5832L101.151 76.611L85.5199 67.5832L101.151 58.5554L116.782 67.5832Z",
    fill: "#ECFFFA",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M116.782 67.5836V49.528L101.151 40.5002L85.5199 49.528V67.5836L101.151 76.6114L116.782 67.5836Z",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M116.782 67.5836L101.151 76.6114V58.5559L116.782 49.5281V67.5836Z",
    fill: "#0F1936",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M101.151 58.5558L85.5199 67.5836V49.528L101.151 40.5002V58.5558Z",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M101.151 76.6114L85.5199 67.5836V49.5281L101.151 58.5559V76.6114Z",
    fill: "#ECFFFA",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M116.782 49.528L101.151 58.5558L85.5199 49.528L101.151 40.5002L116.782 49.528Z",
    fill: "#ECFFFA",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M132.412 76.6112V58.5556L116.781 49.5278L101.151 58.5556V76.6112L116.781 85.6173L132.412 76.6112Z",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M132.412 76.6111L116.781 85.6172V67.5833L132.412 58.5555V76.6111Z",
    fill: "#0F1936",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M116.781 67.5834L101.151 76.6112V58.5556L116.781 49.5278V67.5834Z",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M132.412 58.5556L116.781 67.5834L101.151 58.5556L116.781 49.5278L132.412 58.5556Z",
    fill: "#ECFFFA",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M116.782 49.5278V31.4722L101.151 22.4445L85.5199 31.4722V49.5278L101.151 58.5556L116.782 49.5278Z",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M116.781 49.5276L101.151 58.5554V40.4998L116.781 31.472V49.5276Z",
    fill: "#0F1936",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M101.151 40.5L85.5199 49.5278V31.4722L101.151 22.4445V40.5Z",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M101.151 94.6448L85.5197 85.6171V67.5832L69.8889 58.5554V40.4998L85.5197 49.5276V31.472L101.151 40.4998V58.5554L116.781 67.5832V85.6387L101.151 76.6109V94.6448Z",
    fill: "#ECFFFA",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M116.782 31.4722L101.151 40.5L85.5199 31.4722L101.151 22.4445L116.782 31.4722Z",
    fill: "#ECFFFA",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUseCasesSmall2);
export default __webpack_public_path__ + "static/media/useCasesSmall2.e635a0b9414f2fd4ff01e4dd927fa530.svg";
export { ForwardRef as ReactComponent };